import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { scrollToTop } from '../../../lib/utils';

export default function PrivateRoute({
  consumerHost,
  identityHost,
  isLoggedIn,
  component:
  Component,
  redirectTo,
  render,
  ...rest
}) {
  const renderIfAuth = useCallback((routerProps) => {
    if (isLoggedIn) {
      scrollToTop();
      return Component ? (
        <Component {...routerProps} />
      ) : render(routerProps);
    }

    const pathname = redirectTo || `//${identityHost}/login?return_url=//${consumerHost}${routerProps.location.pathname}`;

    return (
      <Redirect
        to={{
          pathname,
          state: { from: routerProps.location },
        }}
      />
    );
  }, [consumerHost, identityHost, isLoggedIn, redirectTo, render, Component]);

  return (
    <Route {...rest} render={renderIfAuth} />
  );
}

PrivateRoute.propTypes = {
  consumerHost: PropTypes.string,
  identityHost: PropTypes.string,
  isLoggedIn: PropTypes.bool,
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
  redirectTo: PropTypes.string,
  render: PropTypes.func,
};

PrivateRoute.defaultProps = {
  consumerHost: 'www.gasbuddy.com',
  identityHost: 'iam.gasbuddy.com',
  isLoggedIn: false,
  component: undefined,
  redirectTo: undefined,
  render: undefined,
};
